import { useState } from "react";
import styled from "styled-components";

import LightBox from "components/Lightbox";

interface Props {
  images: string[];
}

const ImageCarousel = ({ images }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  const onLightboxClose = () => setIsOpen(false);
  const onLightboxOpen = () => setIsOpen(true);

  return (
    <>
      <ImageContainer>
        <BigImage
          onClick={onLightboxOpen}
          loading="lazy"
          src={images?.[0]}
          alt={`bigImage`}
          width={360}
          height={360}
        />
        <SmallImageContainer>
          <SmallImage
            onClick={onLightboxOpen}
            loading="lazy"
            src={images?.[1]}
            alt={`smallImage_1`}
            width={360}
            height={360}
          />
          <SmallImage
            onClick={onLightboxOpen}
            loading="lazy"
            src={images?.[2]}
            alt={`smallImage_2`}
            width={360}
            height={360}
          />
        </SmallImageContainer>
      </ImageContainer>
      <LightBox
        isOpen={isOpen}
        images={images}
        photoIndex={photoIndex}
        onClose={onLightboxClose}
        setPhotoIndex={setPhotoIndex}
      />
    </>
  );
};

const ImageContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const SmallImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  @media (max-width: ${(props) => props.theme.size.mobileL}) {
    display: none;
  }
`;

const BigImage = styled.img`
  cursor: pointer;
  width: 50%;
  height: calc(50vh);
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  margin-right: 10px;
  object-fit: cover;
  @media (max-width: ${(props) => props.theme.size.mobileL}) {
    width: 100%;
    border-radius: 12px;
  }
`;
const SmallImage = styled.img`
  cursor: pointer;
  width: 100%;
  height: calc(25vh - 5px);
  object-fit: cover;
  &:first-child {
    border-top-right-radius: 12px;
    margin-bottom: 10px;
  }
  &:last-child {
    border-bottom-right-radius: 12px;
  }
`;

export default ImageCarousel;
